module.exports = __webpack_public_path__ + "static/media/member3.84fdf648.png";